import React, {useState} from 'react';
import ScopeButton from 'app/Components/Page/CellcomCareersPage/Shared/Utils/ScopeButton/ScopeButton';
import {useDispatch, useSelector} from 'react-redux';
import {setSelectedUtils} from 'app/Components/Page/CellcomCareersPage/CellcomCareersSlice';

const JobsFilter = ({utilJobsList, adsCareers, updateAds, selectedUtils, handleSelectUtils}) => {
  const setCountOfJobByTitle = (utilJobs) => {
    if (adsCareers.length > 0) {
      const jobsWithUtil = adsCareers.filter((job) => job.utilJobs === utilJobs);

      if (jobsWithUtil.length > 0) {
        const count = jobsWithUtil.length;
        return count;
      } else {
        return 0;
      }
    } else {
      return 0;
    }
  };

  // Sort the utilJobsList based on setCountOfJobByTitle
  const sortedUtilJobsList = utilJobsList.slice().sort((a, b) => {
    const countA = setCountOfJobByTitle(a);
    const countB = setCountOfJobByTitle(b);
    return countB - countA; // Change to countA - countB for ascending order
  });

  return (
    <div
      className={`${
        sortedUtilJobsList.length % 2 !== 0 && window.innerWidth <= 450 ? 'careers__jobs-utils-list__grid-view' : 'careers__jobs-utils-list'
      }`}>
      {sortedUtilJobsList.map((util, index) => (
        <div
          key={index}
          className={`careers__jobs-utils-list__item ${selectedUtils === util ? 'careers__jobs-utils-list__item-select' : ''} ${
            index === sortedUtilJobsList.length - 1 && sortedUtilJobsList.length % 2 !== 0 && window.innerWidth <= 450
              ? 'careers__jobs-utils-list__item__last-item'
              : ''
          }`}>
          <ScopeButton utilTitle={util} countJob={setCountOfJobByTitle(util)} onSelectScope={() => handleSelectUtils(util)} />
        </div>
      ))}
    </div>
  );
};

export default JobsFilter;
